var map = {
	"./en.json": [
		"edd4",
		"chunk-2d230e25"
	],
	"./es.json": [
		"a306",
		"chunk-2d207e6e"
	],
	"./pt-BR.json": [
		"03bd"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39c3";
module.exports = webpackAsyncContext;